import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "800",
  height: "800",
  fill: "currentColor",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M467.076 68.86c-59.902-59.902-156.846-59.896-216.741 0L34.919 284.276c-46.558 46.557-46.558 122.312 0 168.87 46.57 46.571 122.326 46.544 168.87 0L419.205 237.73c33.36-33.36 33.36-87.64 0-121s-87.64-33.361-121 0L114.478 300.457c-6.975 6.975-6.975 18.285 0 25.259s18.285 6.975 25.259 0l183.727-183.727c19.432-19.432 51.05-19.432 70.481 0s19.431 51.05 0 70.481L178.53 427.887c-32.71 32.71-85.646 32.706-118.352 0-15.806-15.806-24.511-36.821-24.511-59.175s8.706-43.369 24.511-59.176L275.594 94.119c45.94-45.94 120.287-45.934 166.222 0 45.827 45.828 45.827 120.395 0 166.222l-95.741 95.741c-6.975 6.975-6.975 18.284 0 25.259s18.285 6.975 25.259 0l95.741-95.741c59.903-59.9 59.896-156.846.001-216.74" }, null, -1)
  ])))
}
export default { render: render }